import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import classNames from 'classnames'
import { trackEvent, trackEventOutbound } from '../util/analytics'
import "./Buttons.css"

export const Button = ({ className, children, ...rest }) => (
  <a type="button"
    className={classNames("button", className)} {...rest}>
    {children}
  </a>
)

export const SimpleButton = ({ className, ...rest }) => (
  <Button className={classNames("simple", className)} {...rest} />
)


export const ButtonLink = ({ className, children, ...rest }) => (
  <Link type="button"
    className={classNames("button", className)} {...rest}>
    {children}
  </Link>
)

export const SimpleButtonLink = ({ className, ...rest }) => (
  <ButtonLink className={classNames("simple", className)} {...rest} />
)


const Tracked = (WrappedComponent) => { 
  const OnClickTracker = (props) => { 
    const { trackingData,  onClick, ...rest } = props; 
    const target = rest.target;
    const to = rest.to;
    const href = rest.href;
   
    const handleClick = (event) => {
      const sameTarget = target !== '_blank';
      const normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button !== 0); 
      if (trackingData.outbound && sameTarget && normalClick) {
        event.preventDefault();
        trackEventOutbound(trackingData, () => { window.location.href = to || href; });
      } else {
        trackEvent(trackingData);
      } 
      onClick && onClick(event);
    };

    return (
      <WrappedComponent onClick={(evt) => handleClick(evt)}  {...rest} />
    );
  };

  return OnClickTracker;
}

export const TrackedButton = Tracked(Button);
export const TrackedSimpleButton = Tracked(SimpleButton);
export const TrackedButtonLink = Tracked(ButtonLink);
export const TrackedSimpleButtonLink = Tracked(SimpleButtonLink);
export const TrackedNavLink = Tracked(NavLink);
export const TrackedLink = Tracked(Link);